import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeatureCollection, Geometry, Point } from 'geojson';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Tempo } from 'src/app/instant-analysis/models/tempo';
import { ServiceService } from 'src/app/instant-analysis/services/service.service';
import { environment } from 'src/environments/environment';
import { GrupoChuvaEstacao } from '../../models/grupo-chuva-estacao';
import { RainDuration } from '../../models/rain-duration';

@Injectable({
  providedIn: 'root'
})
export class HistoryService extends ServiceService {

  constructor(http: HttpClient) { 
    super(http);
  }

  urlChuvaInInterval = `${environment.serverBaseUrl}/chuva/intervalo`
  urlAggregateInInterval = `${environment.serverBaseUrl}/chuva/agregados`;

  /**
   * Busca os dados das estatísticas de chuva das estações em um intervalo de tempo.
   * 
   * @param startDatetime data inicial no formato YYYY-MM-DD hh:mm
   * @param endDatetime data final no formato YYYY-MM-DD hh:mm
   * @returns estatísticas de chuva das estações, e registros de tempo do início e do fim.
   */
  getRainDataInInterval(startDatetime: string, endDatetime: string) {
    
    return this.http.get<{ stationsStats: FeatureCollection<Point>, timeRows: Tempo[] }>(
      this.urlChuvaInInterval,
      {
        params: { startDatetime, endDatetime }
      }
    ).pipe(
      tap((_) => console.log("Got all Rain Data In Interval"))
    );
  }

  /**
   * Busca as linhas de tempo de índice pluviométrico das estações.
   * 
   * @param startDateTime data inicial no formato YYYY-MM-DD hh:mm
   * @param endDateTime data final no formato YYYY-MM-DD hh:mm
   * @param interval resolução de tempo do índice pluviométrico
   * @returns 
   */
  getRainDataAggregatesInInterval(startDateTime: string, endDateTime: string, interval: string): Observable<any> {
    
    return this.http.get<GrupoChuvaEstacao[]>(this.urlAggregateInInterval, {
        params: { startDateTime, endDateTime, interval }
      })
      .pipe(
        tap((_) => console.log("Got all Rain Data Aggregate In Interval"))
      );
  }

  /**
   * Busca as estatísticas de chuvas que foram calculadas usando a chuva interpolada
   * nos centroides dos bairros.
   * 
   * @param startDatetime data inicial no intervalo YYYY-MM-DD hh:mm
   * @param endDatetime data final no intervalo YYYY-MM-DD hh:mm
   * @returns feature collection dos centroides dos bairros com as estatísticas calculadas
   */
  getNeighborhoodRainDataInInterval(startDatetime: string, endDatetime: string) {
    return this.http.get<FeatureCollection<Point>>(`${environment.serverBaseUrl}/chuva/intervalo/bairros`, 
      {
        params: { startDatetime, endDatetime }
      }
    );
  }

  /**
   * Busca a duração das intensidades de chuvas considerando a cidade como um todo.
   * 
   * @param startDatetime data inicial no formato YYYY-MM-DD hh:mm
   * @param endDatetime data final no formato YYYY-MM-DD hh:mm
   * @returns duração total, fraca, moderada, forte, e muito forte da cidade.
   */
  getCityRainDurationInInterval(startDatetime: string, endDatetime: string) {

    return this.http.get<RainDuration>(`${environment.serverBaseUrl}/chuva/intervalo/cidade`,
      {
        params: { startDatetime, endDatetime }
      }
    )
  }
}
